<div class="sku-status">
  <div class="sku-status_showing" *ngIf="getCount()">
    <span
      ><b>Results: {{ getCount() | number }} </b></span
    >
  </div>
</div>
